import instance from "./axios.base";

const getInsurPeople = async () => {
  const res = await instance.get("/typeinsure/person");
  return res.data;
};

export { getInsurPeople };
